import React from 'react';

import TicketDashboardContainer from '@totem/components/ticketing/ticketDashboard/TicketDashboardContainer';
import TicketDashboardLayout from '@totem/components/ticketing/ticketDashboard/TicketDashboardLayout';

const TicketDashboardPage = () => (
  <TicketDashboardContainer>
    <TicketDashboardLayout />
  </TicketDashboardContainer>
);

export default TicketDashboardPage;
